// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUseHsaCustodianInterestTemplatePropertyDto
 */
export interface IUseHsaCustodianInterestTemplatePropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IUseHsaCustodianInterestTemplatePropertyDto
     */
    use_hsa_custodian_interest_template?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IUseHsaCustodianInterestTemplatePropertyDto
     */
    use_hsa_custodian_interest_template_state_id?: IUseHsaCustodianInterestTemplatePropertyDtoUseHsaCustodianInterestTemplateStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IUseHsaCustodianInterestTemplatePropertyDtoUseHsaCustodianInterestTemplateStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IUseHsaCustodianInterestTemplatePropertyDto interface.
 */
export function instanceOfIUseHsaCustodianInterestTemplatePropertyDto(value: object): value is IUseHsaCustodianInterestTemplatePropertyDto {
    return true;
}

export function IUseHsaCustodianInterestTemplatePropertyDtoFromJSON(json: any): IUseHsaCustodianInterestTemplatePropertyDto {
    return IUseHsaCustodianInterestTemplatePropertyDtoFromJSONTyped(json, false);
}

export function IUseHsaCustodianInterestTemplatePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUseHsaCustodianInterestTemplatePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'use_hsa_custodian_interest_template': json['use_hsa_custodian_interest_template'] == null ? undefined : json['use_hsa_custodian_interest_template'],
        'use_hsa_custodian_interest_template_state_id': json['use_hsa_custodian_interest_template_state_id'] == null ? undefined : json['use_hsa_custodian_interest_template_state_id'],
    };
}

export function IUseHsaCustodianInterestTemplatePropertyDtoToJSON(json: any): IUseHsaCustodianInterestTemplatePropertyDto {
    return IUseHsaCustodianInterestTemplatePropertyDtoToJSONTyped(json, false);
}

export function IUseHsaCustodianInterestTemplatePropertyDtoToJSONTyped(value?: IUseHsaCustodianInterestTemplatePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'use_hsa_custodian_interest_template': value['use_hsa_custodian_interest_template'],
        'use_hsa_custodian_interest_template_state_id': value['use_hsa_custodian_interest_template_state_id'],
    };
}

